import type { ComponentPropsWithRef, ReactNode } from 'react'

import { cn } from '../lib/cn'
import { classesChamp } from './champ'

export interface OptionSelect {
  readonly valeur: string
  readonly libelle: string
  readonly desactive?: boolean | undefined
}

export interface SelectProps extends Omit<ComponentPropsWithRef<'select'>, 'children'> {
  readonly invalide?: boolean | undefined
  /** Liste d’options ; sinon, passer des `<option>` via `children`. */
  readonly options?: readonly OptionSelect[] | undefined
  /** Ajoute une première option vide (« — choisir — »). */
  readonly placeholder?: string | undefined
  readonly children?: ReactNode | undefined
}

export function Select({
  invalide = false,
  options,
  placeholder,
  className,
  children,
  ...reste
}: SelectProps) {
  return (
    <div className="relative">
      <select
        className={cn(
          classesChamp(invalide),
          'appearance-none pr-9',
          // Sans valeur choisie, le placeholder reste gris : on voit d’un coup
          // d'œil les listes déroulantes encore vides d’un formulaire.
          (reste.value === '' || reste.defaultValue === '') && 'text-slate-500',
          className,
        )}
        aria-invalid={invalide || undefined}
        {...reste}
      >
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options?.map((option) => (
          <option key={option.valeur} value={option.valeur} disabled={option.desactive === true}>
            {option.libelle}
          </option>
        ))}
        {children}
      </select>
      <svg
        className="pointer-events-none absolute inset-y-0 right-3 my-auto size-4 text-slate-500"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        aria-hidden="true"
      >
        <path d="m6 8 4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}
